import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import PageContainer from '../PageContainer/PageContainer';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import DeliveryAddressBook from '../DeliveryAddressBook/DeliveryAddressBook';
import { useAppSelector } from '../../store/hooks';
import useAccountBreadcrumb from '../shared/useAccountBreadcrumb';
import '../shared/ordersPageShell.css';
import '../MyAccount/MyAccount.css';

const SavedAddresses: React.FC = () => {
  const { user, isAuthenticated, authReady } = useAppSelector((state) => state.user);
  const breadcrumbItems = useAccountBreadcrumb([
    { label: 'My Account', path: '/my-account' },
    { label: 'Address Book', active: true },
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const displayName = (() => {
    if (!user) return '';
    const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
    if (fullName) return fullName;
    if (user.userName?.trim()) return user.userName.trim();
    return '';
  })();

  const showSignInPrompt = authReady && !isAuthenticated;

  return (
    <div className="my-account-page">
      <Header />
      <PageContainer>
        <div className="orders-page-shell">
          <Breadcrumb items={breadcrumbItems} />
          <div className="account-page-header">
            <h1 className="account-page-title">Address Book</h1>
          </div>
          <div className="my-account-container">
            {showSignInPrompt ? (
              <div className="my-account-card my-account-signin-prompt">
                <p>Sign in to save and manage delivery addresses.</p>
                <Link to="/signin?redirect=/saved-addresses" className="my-account-signin-link">
                  <i className="fa fa-sign-in" aria-hidden />
                  Sign in
                </Link>
              </div>
            ) : (
              <div className="my-account-card">
                {isAuthenticated && (
                  <DeliveryAddressBook
                    defaultName={displayName}
                    defaultPhone={user?.phoneNumber}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </PageContainer>
      <Footer />
    </div>
  );
};

export default SavedAddresses;
